import * as types from './actionTypes';

export function showSpinner() {
    return {type: types.SHOW_SPINNER_SUCCESS, status: true};
}

export function hideSpinner() {
    return {type: types.HIDE_SPINNER_SUCCESS, status: false};
}

export function addSpinnerButton(buttonId) {
    return {type: types.ADD_SPINNER_BUTTON_SUCCESS, buttonId: buttonId};
}

export function removeSpinnerButton(buttonId) {
    return {type: types.REMOVE_SPINNER_BUTTON_SUCCESS, buttonId: buttonId};
}


// WEBPACK FOOTER //
// ./web/src/actions/spinnerActions.js